import { useMemo } from "react";

// emitter.ts
export type Emitter<T> = {
  emit: (value: T) => void;
  subscribe: (listener: (value: T) => void) => () => void; // returns unsubscribe
};

const createEmitter = <T = void>(): Emitter<T> => {
  const listeners = new Set<(value: T) => void>();

  return {
    emit(value: T) {
      for (const fn of listeners) {
        fn(value);
      }
    },
    subscribe(listener: (value: T) => void) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
};

export const useEventEmitter = <T = void>(
  passedEventEmitter?: Emitter<T>
): Emitter<T> => {
  const emitter = useMemo(() => createEmitter<T>(), []);

  if (passedEventEmitter) {
    return passedEventEmitter;
  }

  const emit = (data: T) => {
    emitter.emit(data);
  };

  return {
    ...emitter,
    emit,
  };
};
